var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#ef6545"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.985,4.336A1.016,1.016,0,1,0,3.969,3.32,1.015,1.015,0,0,0,4.985,4.336",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.351,4.336A1.016,1.016,0,1,0,9.336,3.32a1.015,1.015,0,0,0,1.015,1.016",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.988,4.7H4.031A1.1,1.1,0,0,0,2.907,5.781L3.1,9.037a1.084,1.084,0,0,0,.769,1.023A.186.186,0,0,1,4,10.22l.28,2.408a.723.723,0,0,0,.732.658h0a.723.723,0,0,0,.732-.658l.281-2.408a.185.185,0,0,1,.132-.16,1.085,1.085,0,0,0,.77-1.023l.187-3.256A1.1,1.1,0,0,0,5.988,4.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.663,9.811l-.908-3.883A1.336,1.336,0,0,0,10.366,4.9,1.335,1.335,0,0,0,8.978,5.928l-.9,3.883A1.1,1.1,0,0,0,8.9,11.2h.564l.165,1.426a.739.739,0,0,0,1.469,0l.165-1.426h.573C12.3,11.2,12.792,10.541,12.663,9.811Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/TOILET.62621c901479be780c126add20ee9545.svg";
export { ForwardRef as ReactComponent };